import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { CellMeasurer } from 'react-virtualized'

const propTypes = {
  style: PropTypes.object.isRequired,
}

export default function ActivityRowPlaceholder({
  style,
  cache,
  index,
  parent,
}) {
  return (
    <CellMeasurer
      cache={cache}
      columnIndex={0}
      rowIndex={index}
      parent={parent}
    >
      <div
        className={classNames('activity-row-container padding-top-large')}
        style={{
          ...style,
          right: 0,
          minHeight: 100,
        }}
      />
    </CellMeasurer>
  )
}

ActivityRowPlaceholder.propTypes = propTypes
